import { render, staticRenderFns } from "./writeoff-detail.vue?vue&type=template&id=6565eff3&scoped=true&"
import script from "./writeoff-detail.vue?vue&type=script&lang=js&"
export * from "./writeoff-detail.vue?vue&type=script&lang=js&"
import style0 from "./writeoff-detail.vue?vue&type=style&index=0&id=6565eff3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565eff3",
  null
  
)

export default component.exports